import { tokens } from '../theme';

export function Skeleton({
  width = '100%',
  height = 16,
  radius = 4,
}: {
  width?: number | string;
  height?: number;
  radius?: number;
}) {
  return (
    <span
      aria-hidden="true"
      style={{
        display: 'inline-block',
        width,
        height,
        borderRadius: radius,
        background: tokens.color.paper[100],
        backgroundImage: `linear-gradient(90deg, ${tokens.color.paper[100]} 0%, ${tokens.color.paper[200]} 50%, ${tokens.color.paper[100]} 100%)`,
        backgroundSize: '200% 100%',
        animation: 'shimmer 1.6s ease-in-out infinite',
      }}
    />
  );
}
